import React from 'react'

const TabPanel = (props) => {
    const { classes, children, value, index, ...other } = props;

    return (
        <>
            <div
                component="div"
                role="tabpanel"
                hidden={value !== index}
                id={'simple-tabpanel-' + index}
                aria-labelledby={'simple-tab-' + index}
                {...other}
            >
                {children}
            </div>
        </>
    )
}

export default (TabPanel);
